/**
 * Fuente única de "qué casas ve el vecino en el portal": sus tenencias (como
 * titular) + las casas donde es autorizado de portal (residente con
 * cuenta_portal_activa). Ambas dan lectura del estado de cuenta de la casa.
 * Usado por el selector de casa de VecinoHome / EstadoCuenta / MiHistorial.
 */
import type { AuthMeResponse } from './api/types';

export interface CasaSelector {
  lote_id: string;
  lote_identificador: string;
}

export function casasDelVecino(me: AuthMeResponse | null): CasaSelector[] {
  return [
    ...(me?.tenencias_activas ?? []).map((t) => ({
      lote_id: t.lote_id,
      lote_identificador: t.lote_identificador,
    })),
    ...(me?.casas_autorizadas ?? []).map((c) => ({
      lote_id: c.lote_id,
      lote_identificador: c.lote_identificador,
    })),
  ];
}
